import { useEffect } from 'react';

/**
 * Set the browser tab title in the CogniEtica convention:
 *   "CogniEtica — Canal de Denúncias — {Tenant Name}"
 *
 * Falls back to "CogniEtica — Canal de Denúncias" when no tenant is known
 * (public homepage, login page, super-admin console).
 *
 * Optional `page` param appends a suffix so specific admin views can add
 * their own label without duplicating the tenant name each time:
 *   usePageTitle(tenant?.name, "Dashboard")
 *   → "CogniEtica — Canal de Denúncias — Acme · Dashboard"
 *
 * Cleans up on unmount by restoring the previous title, so a per-page
 * override in a modal doesn't leak into the parent page.
 */
const BASE = 'CogniEtica — Canal de Denúncias';

export const buildPageTitle = (tenantName, page) => {
  const parts = [BASE];
  if (tenantName) parts.push(tenantName);
  let title = parts.join(' — ');
  if (page) title += ` · ${page}`;
  return title;
};

export const usePageTitle = (tenantName, page) => {
  useEffect(() => {
    const previous = document.title;
    document.title = buildPageTitle(tenantName, page);
    return () => { document.title = previous; };
  }, [tenantName, page]);
};

export default usePageTitle;
